import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSendReleaseEmailMutation } from '../../api/api-hooks';
import { SoftwareVersionForm } from './linksTypes';
import { emailBuilder } from './linksUtils';

interface Props {
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  addFormState: SoftwareVersionForm;
}

const NewVersionEmailDialog = ({
  dialogOpen,
  setDialogOpen,
  addFormState,
}: Props) => {
  const [sendReleaseEmail] = useSendReleaseEmailMutation();
  const [message, setMessage] = useState<string>('');
  const [result, setResult] = useState<string>('');
  useEffect(() => {
    setMessage(
      emailBuilder(
        addFormState.versionNumber || '',
        addFormState.software || undefined
      )
    );
  }, [addFormState.versionNumber, addFormState.software]);
  const closeDialog = () => {
    setDialogOpen(false);
    setResult('');
  };
  const sendEmails = async () => {
    if (!addFormState.software || !addFormState.versionNumber) return;
    setResult('Sending...');
    const result = await sendReleaseEmail({
      sendVersionReleaseEmailDto: {
        message: message,
        softwareId: addFormState.software.id,
        versionNumber: addFormState.versionNumber,
      },
    });
    if ('data' in result) {
      setResult('Emails sent.');
    } else {
      setResult('Something went wrong.');
    }
  };
  const handleChange = (event: any) => {
    const { value } = event.target;
    setMessage(value);
  };
  return (
    <Dialog
      fullWidth
      maxWidth='md'
      open={dialogOpen}
      aria-labelledby='form-dialog-title'
    >
      <DialogTitle id='form-dialog-title'>
        Send Version Release Email
      </DialogTitle>
      <DialogContent>
        <Grid container direction='column' spacing={2}>
          <Grid item>
            <TextField
              multiline
              fullWidth
              rows={25}
              value={message}
              onChange={handleChange}
              variant='outlined'
            />
          </Grid>
          <Grid item>
            <Typography color='error'>
              When you click 'send', the email will be sent to every portal user
              whose company has a license for {addFormState?.software?.type}.
            </Typography>
          </Grid>
          {result && (
            <Grid item>
              <Typography>{result}</Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        {!result && (
          <Button onClick={sendEmails} color='primary'>
            Send
          </Button>
        )}
        <Button onClick={closeDialog} color='error'>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewVersionEmailDialog;
